import React, { useState } from 'react';
import { Button, Checkbox, Header, Icon, List, Segment } from 'semantic-ui-react';
import TierLabel from '../subcomponents/TierLabel';
import { RECOMMENDATION_TIERS, getOptionText } from '../constants';
import { formatTime } from '../PhoneSystemStep/hoursUtils';
import { SEQUENCE_STEP_TYPES, describeStepTiming } from './messagingUtils';

const ConfirmMessaging = ({ textTemplates, emailTemplates, sequence, triggerText, isApprovedInitially = false, onBack, onConfirm }) => {
    const [isApproved, setIsApproved] = useState(isApprovedInitially);
    const allTemplates = [...textTemplates, ...emailTemplates];
    const getTemplateName = (template_id) => allTemplates.find(({ id }) => id === template_id)?.name;

    return (
        <Segment>
            <Header as='h3'>
                Confirm Your Messaging Setup
                <Header.Subheader>Saved as a draft. Templates and the sequence are created at launch.</Header.Subheader>
            </Header>

            <Header as='h4'>Text Templates ({textTemplates.length}) <TierLabel tier={RECOMMENDATION_TIERS.REQUIRES_ACTIVATION} /></Header>
            {textTemplates.length ? (
                <List divided relaxed>
                    {textTemplates.map(({ id, name, message }) => (
                        <List.Item key={id}>
                            <List.Icon name='comment alternate outline' color='blue' />
                            <List.Content>
                                <List.Header>{name}</List.Header>
                                <List.Description><i>"{message}"</i></List.Description>
                            </List.Content>
                        </List.Item>
                    ))}
                </List>
            ) : <p>No text templates.</p>}

            <Header as='h4'>Email Templates ({emailTemplates.length})</Header>
            {emailTemplates.length ? (
                <List divided relaxed>
                    {emailTemplates.map(({ id, name, subject }) => (
                        <List.Item key={id}>
                            <List.Icon name='mail outline' color='blue' />
                            <List.Content>
                                <List.Header>{name}</List.Header>
                                <List.Description>Subject: {subject}</List.Description>
                            </List.Content>
                        </List.Item>
                    ))}
                </List>
            ) : <p>No email templates.</p>}

            <Header as='h4'>Follow-Up Sequence{sequence.included ? `: ${sequence.name}` : ''}</Header>
            {sequence.included ? (
                <>
                    <p>{triggerText}. {sequence.saturday || sequence.sunday ? `Also runs on ${[sequence.saturday && 'Saturday', sequence.sunday && 'Sunday'].filter(Boolean).join(' and ')}.` : 'Weekdays only.'}</p>
                    <List ordered relaxed>
                        {sequence.steps.map(step => (
                            <List.Item key={step.id}>
                                <b>{getOptionText(SEQUENCE_STEP_TYPES, step.type)}</b>
                                {' · '}{describeStepTiming(step, formatTime)}
                                {step.type !== 'call' && ` · ${getTemplateName(step.template_id)}`}
                            </List.Item>
                        ))}
                    </List>
                </>
            ) : <p>No sequence. You can build one later in Settings → Automation → Sequences.</p>}

            <Segment secondary>
                <Checkbox
                    checked={isApproved}
                    onChange={(_, { checked }) => setIsApproved(checked)}
                    label="I've reviewed these messages and the sequence and approve them as my configuration draft"
                />
            </Segment>
            <Button basic type='button' onClick={onBack}><Icon name='arrow left' /> Back</Button>
            <Button primary floated='right' type='button' disabled={!isApproved} onClick={onConfirm}>
                Continue to Import & Integrations <Icon name='arrow right' />
            </Button>
            <div style={{ clear: 'both' }} />
        </Segment>
    );
}

export default ConfirmMessaging;
